import React from 'react'

import Content, { Theme as ContentTheme } from 'components/base/Content'
import Title from 'components/base/Title'
import ButtonRow from 'components/base/Button/Row'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import Form from 'components/base/Form'
import { Type as InputType } from 'components/base/Form/Input'
import InputGroup from 'components/base/Form/InputGroup'
import RadioOption from 'components/base/Form/Input/Radio/Option'
import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'
import {
  QuoteIconWheel,
  QuoteIconDollarSign,
} from 'components/base/Icon/styles'
import SectionDivider from 'components/base/SectionDivider'
import ProgressBar, { Type as ProgressBarType } from 'components/blocks/ProgressBar'

const AutoAdditionalInfo: React.FC = (): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.auto}>
    <ProgressBar type={ProgressBarType.autoRc2} current='carrier' />

    <Title level={3}>
      Annika, please complete the following information so we can confirm
      your details.
    </Title>
    <Content theme={ContentTheme.paper} center={true}>
      <SectionDivider icon={<QuoteIconWheel />} title='Vehicle Details' />
      <Title level={3}>2019 Highlander Hybrid</Title>
      <Content margined={true}>
        <Form>
          <InputGroup
            label='Was this vehicle purchased by you?'
            type={InputType.radio}
            name='VehiclePurchaser'
            defaultValue={true}
            rules='required'
          >
            <RadioOption value={true}>Yes</RadioOption>
            <RadioOption value={false}>No</RadioOption>
          </InputGroup>
          <InputGroup
            label='What is this vehicle’s VIN #?'
            type={InputType.text}
            rules='required'
          />
        </Form>
      </Content>
    </Content>
    <Content margined={true}>
      <SectionDivider
        icon={<QuoteIconDollarSign />}
        title='Payment Details'
      />
      <InputGroup
        label='Preferred Payment Method'
        type={InputType.radio}
        name='PaymentMethod'
        defaultValue='cc'
        rules='required'
      >
        <RadioOption value='cc'>Credit Card</RadioOption>
        <RadioOption value='eft'>
          Electronic Funds Transfer (EFT)
        </RadioOption>
        <RadioOption value='other'>Other</RadioOption>
      </InputGroup>
      <InputGroup
        label='Preferred Billing Period'
        type={InputType.radio}
        name='BillingPeriod'
        defaultValue='monthly'
        rules='required'
      >
        <RadioOption value='monthly'>Monthly</RadioOption>
        <RadioOption value='quarterly'>Quarterly</RadioOption>
        <RadioOption value='annually'>Annually</RadioOption>
      </InputGroup>
      <ButtonRow>
        <Link center={true} wide={true} theme={LinkTheme.button} to='/quote/new/loading/type-a'>
          Next
        </Link>
      </ButtonRow>
    </Content>
  </QuotingWrapper>
)

export default AutoAdditionalInfo
